import React from 'react';
import { ContinuosReportingType } from '../ContinuosReporting';
import ContinuosReportingDeleteModal from './ContinuosReportingDeleteModal';
import ContinuosReportingUpdateModal from './ContinuosReportingUpdateModal';

interface ContinuosReportingActionCellProps {
	data: ContinuosReportingType;
	fetchData: () => void;
	isCoordinator: boolean;
	isEnabledToView: boolean;
	state: 'DRAFT' | 'VALIDATED';
	isBeneficiary: boolean;
	isProjectWp: boolean;
}

const ContinuosReportingActionCell: React.FC<ContinuosReportingActionCellProps> = ({
	data,
	fetchData,
	isCoordinator,
	isEnabledToView,
	state,
	isBeneficiary,
	isProjectWp,
}) => {
	return (
		<div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
			<ContinuosReportingUpdateModal
				data={data}
				fetchData={fetchData}
				isCoordinator={isCoordinator}
            isEnabledToView={isEnabledToView}
				isBeneficiary={isBeneficiary}
				state={state}
				isProjectWp={isProjectWp}
			/>
			{state === 'DRAFT' && !isBeneficiary ? <ContinuosReportingDeleteModal data={data} fetchData={fetchData} /> : null}
		</div>
	);
};

export default ContinuosReportingActionCell;
